import { render, staticRenderFns } from "./MessageMediaGallery.vue?vue&type=template&id=2dfb91ff&scoped=true&"
import script from "./MessageMediaGallery.vue?vue&type=script&lang=ts&"
export * from "./MessageMediaGallery.vue?vue&type=script&lang=ts&"
import style0 from "./MessageMediaGallery.vue?vue&type=style&index=0&id=2dfb91ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfb91ff",
  null
  
)

export default component.exports